// 0: React
// 1: Print
// 2: Web Design
// 3: Motion
// 4: Logotype
// 5: WordPress
// 6: All

import blockscan from "../../Assets/blockscan.png";
import blockscanModal from "../../Assets/blockscanModal.jpg";
import shadow from "../../Assets/shadow.jpg";
import shadowModal from "../../Assets/shadowModal.jpg";
import hug from "../../Assets/hug.jpg";
import hugModal from "../../Assets/hugModal.jpg";
import wowway from "../../Assets/wowway.jpg";
import wowwayModal from "../../Assets/wowwayModal.png";
import lovely from "../../Assets/lovely.jpg";
import lovelyModal from "../../Assets/lovelyModal.jpg";
import better from "../../Assets/better.jpg";
import betterModal from "../../Assets/betterModal.jpg";
import just from "../../Assets/just.jpg";
import justModal from "../../Assets/justModal.jpg";
import flat from "../../Assets/flat.jpg";
import flatModal from "../../Assets/flatModal.jpg";
import stationary from "../../Assets/stationary.jpg";
import stationaryModal from "../../Assets/stationaryModal.jpg";
import improbable from "../../Assets/improbable.jpg";
import improbableModal from "../../Assets/improbableModal.jpg";
import inmynewworld from "../../Assets/inmynewworld.jpg";
import inmynewworldModal from "../../Assets/inmynewworldModal.jpg";
import flat2 from "../../Assets/flat2.jpg";
import flat2Modal from "../../Assets/flat2Modal.jpg";
import move from "../../Assets/move.jpg";
import moveModal from "../../Assets/moveModal.jpg";
import perfect from "../../Assets/perfect.jpg";
import perfectModal from "../../Assets/perfectModal.jpg";
import business from "../../Assets/business.jpg";
import businessModal from "../../Assets/businessModal.jpg";
import more from "../../Assets/more.jpg";
import moreModal from "../../Assets/moreModal.jpg";
import self from "../../Assets/self.jpg";
import selfModal from "../../Assets/selfModal.jpg";
import stationary2 from "../../Assets/stationary2.jpg";
import stationary2Modal from "../../Assets/stationary2Modal.jpg";
import password from "../../Assets/password.jpg";
import passwordModal from "../../Assets/passwordModal.jpg";
import custom from "../../Assets/custom.jpg";
import customModal from "../../Assets/customModal.jpg";

export default [
  {
    id: 0,
    img: blockscan,
    tag: 0,
    Text: "BlockScan",
    SubText: "Ethereum Blockchain Explorer",
    Modal: {
      img: blockscanModal,
      Explain:
        "이더리움 블록체인 익스플로러 클론코딩\n\nEtherScan.io를 클론코딩한 프로젝트로서 이더리움 블록체인에서 일어나고 있는 모든 활동과 정보를 쉽게 검색할 수 있는 사이트 입니다.\n\n단순히 기능 개발에서 멈추지 않고, 실무에서 사용하는 기술과 협업툴을 적용하였습니다.",
      Tech:
        "Tech Stack\n- React.js\n- Node.js\n- Mysql\n- Sequelize\n- Express\n- Swagger\n- Jenkins\n- Crontab\n- Nginx\n- Docker\n",
      Link: "https://blockscan.netlify.app/",
      Github: "https://github.com/IGMD/blockscan",
      Notion:
        "https://www.notion.so/IGMM-BLOCK-EXPLORER-88a81bf42fbc40b2b614724562dde11b",
    },
  },
  {
    id: 1,
    img: shadow,
    tag: 2,
    Text: "Shadow – WP Theme",
    SubText: "Web Design, WordPress",
    Modal: {
      img: shadowModal,
      Explain:
        "Aenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet ferm entumone non mi porta. Aenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed consectetur. Aenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet ferm entumone non mi porta. Aenean lacinia bibendum nulla sed consectetur.\n\nCras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed consectetur.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 2,
    img: hug,
    tag: 4,
    Text: "Huge – WP Theme",
    SubText: "Logotype, WordPress",
    Modal: {
      img: hugModal,
      Explain:
        "Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 3,
    img: wowway,
    tag: 2,
    Text: "Wowway – WP Theme",
    SubText: "Web Design, WordPress",
    Modal: {
      img: wowwayModal,
      Explain:
        "Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 4,
    img: lovely,
    tag: 3,
    Text: "Lovely Charts",
    SubText: "Motion, Web Design",
    Modal: {
      img: lovelyModal,
      Explain:
        "Aenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet ferm entumone non mi porta. Aenean lacinia bibendum nulla sed consectetur.\n\nCras mattis consectetur purus sit amet.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 5,
    img: better,
    tag: 1,
    Text: "Better Packaging",
    SubText: "Print",
    Modal: {
      img: betterModal,
      Explain:
        "A very bad quack might jinx zippy fowls. Few quips galvanized the mock jury box. Quick brown dogs jump over the lazy fox. The jay, pig, fox, zebra, and my wolves quack!",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 6,
    img: just,
    tag: 2,
    Text: "Just Packaging",
    SubText: "Web Design",
    Modal: {
      img: justModal,
      Explain:
        "Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using. Benefactor, monogram blissfull politically wishlist luxury wishlist. Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using. Benefactor, monogram blissfull politically wishlist luxury wishlist.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 7,
    img: flat,
    tag: 4,
    Text: "Flat Icons #1",
    SubText: "Logotype",
    Modal: {
      img: flatModal,
      Explain:
        "Cuisine investments cultered, rich fashion yacht fashion noble five-star dignified benefactor. In yacht manor status rich charity diamond acumen travel elegant travel gifted benefiting. Presidential enthusiast butler panoramic acumen benefiting. Gifted guests rich cigar career, brilliant gentlemen philanthropic gentlemen acumen philanthropic purebred acumen benefactor sterling.\n\nCuisine invesIn yacht manor status rich charity diamond acumen travel elegant travel gifted benefiting. Presidential enthusiast butler panoramic acumen benefiting. Gifted guests rich cigar career, brilliant gentlemen philanthropic gentlemen acumen philanthropic purebred acumen benefactor sterling.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 8,
    img: stationary,
    tag: 1,
    Text: "Stationary Branding #2",
    SubText: "Print",
    Modal: {
      img: stationaryModal,
      Explain:
        "Client\n\nHe could see from the bed that it had been set for four o’clock as it should have been it certain. It was half past six and the hands were quietly moving forwards, it was even later than half past, more like quarter to seven. Had the alarm clock not rung?\n\nChallenge\n\nIt was half past six and the hands were quietly moving forwards, it was even later than half past, more like quarter to seven. Had the alarm clock not rung? He could see from the bed that it had been set for four o’clock as it should have been; it certainly must have rung. Yes, but was it possible to quietly sleep.\n\nResult\n\nIt was half past six and the hands were quietly moving forwards, it was even later than half past, more like quarter to seven. Had the alarm clock not rung? He could see from the bed that it had been set for four o’clock as it should have been it certain it was half .",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 9,
    img: improbable,
    tag: 4,
    Text: "Improbable Identity",
    SubText: "Logotype",
    Modal: {
      img: improbableModal,
      Explain:
        "Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using. Benefactor, monogram blissfull politically wishlist luxury wishlist. Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using. Benefactor, monogram blissfull politically wishlist luxury wishlist.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 10,
    img: inmynewworld,
    tag: 3,
    Text: "In My New World",
    SubText: "Motion",
    Modal: {
      img: inmynewworldModal,
      Explain:
        "Aenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet ferm entumone non mi porta. Aenean lacinia bibendum nulla sed consectetur.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 11,
    img: flat2,
    tag: 1,
    Text: "Flat Icons #2",
    SubText: "Print",
    Modal: {
      img: flat2Modal,
      Explain:
        "Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using. Benefactor, monogram blissfull politically wishlist luxury wishlist. Using, auction cigar distinctly brilliant estate in acumen townhome, pedigree impresario manor wishlist rich. Marquis five-star, dignified educated fine cocktail vacation regal metropolitan repertoire impressive imported treasure brokerage using. Benefactor, monogram blissfull politically wishlist luxury wishlist.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 12,
    img: move,
    tag: 3,
    Text: "Move",
    SubText: "Motion, Web Design",
    Modal: {
      img: moveModal,
      Explain:
        "I am so happy, my dear friend, so absorbed in the exquisite sense of mere tranquil existence, that I neglect my talents.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 13,
    img: perfect,
    tag: 4,
    Text: "Perfect Packaging",
    SubText: "Logotype, Print",
    Modal: {
      img: perfectModal,
      Explain:
        "Cuisine investments cultered, rich fashion yacht fashion noble five-star dignified benefactor. In yacht manor status rich charity diamond acumen travel elegant travel gifted benefiting. Presidential enthusiast butler panoramic acumen benefiting. Gifted guests rich cigar career, brilliant gentlemen philanthropic gentlemen acumen philanthropic purebred acumen benefactor sterling.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 14,
    img: business,
    tag: 4,
    Text: "Business Cards",
    SubText: "Logotype, Print",
    Modal: {
      img: businessModal,
      Explain:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nisl orci, condim entum ultrices consequat eu, vehicula ac mauris. Ut adipiscing, leo nec. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 15,
    img: more,
    tag: 3,
    Text: "More Videos",
    SubText: "Motion",
    Modal: {
      img: moreModal,
      Explain:
        "By sharing information about products you use, you are also improving recommendations for others. Recommendations are better when they’re based on more data.\n\nWith smart data analysis we discover which products are used by other people with a skin just like yours. Individuals with the same skin properties find same products fitting them best.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 16,
    img: self,
    tag: 3,
    Text: "Self Hosted Video",
    SubText: "Motion",
    Modal: {
      img: selfModal,
      Explain:
        "Cuisine investments cultered, rich fashion yacht fashion noble five-star dignified benefactor. In yacht manor status rich charity diamond acumen travel elegant travel gifted benefiting.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 17,
    img: stationary2,
    tag: 5,
    Text: "Stationary Binding #2",
    SubText: "WordPress",
    Modal: {
      img: stationary2Modal,
      Explain:
        "Client\n\nHe could see from the bed that it had been set for four o’clock as it should have been it certain. It was half past six and the hands were quietly moving forwards, it was even later than half past, more like quarter to seven. Had the alarm clock not rung?\n\nChallenge\n\nIt was half past six and the hands were quietly moving forwards, it was even later than half past, more like quarter to seven. Had the alarm clock not rung? He could see from the bed that it had been set for four o’clock as it should have been; it certainly must have rung. Yes, but was it possible to quietly sleep.\n\nResult\n\nIt was half past six and the hands were quietly moving forwards, it was even later than half past, more like quarter to seven. Had the alarm clock not rung? He could see from the bed that it had been set for four o’clock as it should have been it certain it was half .",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 18,
    img: password,
    tag: 1,
    Text: "Password Protected",
    SubText: "Print",
    Modal: {
      img: passwordModal,
      Explain:
        "ProtectedText is an free online notepad with password, where you can securely save your notes on the web.\n\nIt's a secure notepad with password, for all your notes, ideas, to-do lists, scripts, etc. You can store notes online at ProtectedText.com/ANY_SITE_YOU_TYPE and access from any web browser. It's free and also without ads and tracking, and you don't even have to register or have any kind of account. Store your notes anonymously and encrypted in this simple and secure free online notepad. You can also use our Android app to access your notes conveniently from your Android device.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
  {
    id: 19,
    img: custom,
    tag: 5,
    Text: "Custom Link",
    SubText: "WordPress",
    Modal: {
      img: customModal,
      Explain:
        "If you’ve ever added hyperlinks to a message, you probably already know that URLs can get long and ugly. You can change the link text to something easier to read that tells people what the link is about.",
      Tech: "",
      Link: "",
      Github: "",
      Notion: "",
    },
  },
];
